
  import React from "react"
  import Component from "/home/appveyor/projects/domiz-io/src/layouts/index.js"
  import data from "/home/appveyor/projects/domiz-io/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js